// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"2ea6df72","353":"cd6f3d35"}[chunkId] + ".chunk.css";
};